<script>
export default {
  props: {
    mediaPath: String,
  },
  data() {
    return {
      href: null,
    }
  },
  created() {
    this.downloadFile(this.mediaPath)
  },
  methods: {
    async downloadFile(mediaPath) {
      if (mediaPath) {
        const response = await this.$http.get(
          `/api/chats/download-file/${mediaPath}`,
          {
            responseType: "blob",
          }
        )

        console.log(`download file response: ${response}`)

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        })

        this.href = URL.createObjectURL(blob)

        // add file reader here
        // const fileReader = new FileReader()

        // fileReader.readAsDataURL(blob)

        // fileReader.onload((event) => {
        //     // this.chatRooms[index].chats[chatIndex].file =
        //     //     event.target.result
        //     console.log(event.target.result)
        // })
      }
    },
  },
}
</script>

<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center w-100 h-100 bg-white rounded-lg p-1"
  >
    <a :href="href" :download="mediaPath">
      <feather-icon icon="DownloadIcon" class="text-muted" size="50" />
    </a>
    <h6>{{ mediaPath.split("_")[2] }}</h6>
  </div>
</template>
